import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Details } from './components';
import useRecipientQueries from './useRecipientQueries';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const RecipientQueryDetails = props => {
  const template = useRecipientQueries();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Details
          template={template}
          showNav={true}
          next="/recipient-queries/design"
        />
      </div>
    </div>
  );
};

export default RecipientQueryDetails;
